export function convertGalleryIdToName(gallery) {
    return gallery
        .replace("-", " ")
        .replace(/(?:^|\s)\w/g, match => match.toUpperCase());
}



// WEBPACK FOOTER //
// ./src/util/gallery.js